import React, { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { CircularProgress, Modal, Box } from '@mui/material';

import PreviewModal from '../../../components/PreviewModal/PreviewModal';

import { getPolicyById, resetPolicyDetails } from 'store/reducers/legalSlice';

const PreviewPolicy = memo(({ openModal, onCloseModal, selectedPolicy }) => {
  const dispatch = useDispatch();

  const [isFetchingPolicy, setFetchingPolicy] = useState(false);

  const { policyDetails } = useSelector((state) => state.legal);

  async function fetchPolicy() {
    try {
      setFetchingPolicy(true);
      await dispatch(getPolicyById(selectedPolicy?.id));
    } catch (error) {
      console.log({ error });
      onCloseModal();
    } finally {
      setFetchingPolicy(false);
    }
  }

  useEffect(() => {
    if (selectedPolicy?.id) {
      fetchPolicy();
    }
  }, [selectedPolicy]);

  useEffect(() => {
    return () => {
      dispatch(resetPolicyDetails());
    };
  }, []);

  return (
    <Modal
      open={openModal}
      onClose={(_, reason) => {
        if (reason === 'backdropClick') return;
        onCloseModal();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      disableEscapeKeyDown
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          maxHeight: 'calc(100vh - 100px)',
          overflow: 'auto',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 3,
          minWidth: '500px',
          minHeight: '500px',
        }}
      >
        {isFetchingPolicy ? (
          <Box
            sx={{
              minHeight: '468px',
              display: 'grid',
              placeItems: 'center',
            }}
          >
            <CircularProgress color="info" />
          </Box>
        ) : (
          <PreviewModal
            modalTitle={policyDetails?.title}
            modalContent={policyDetails?.content ?? <p>No Content</p>}
            onCloseModal={onCloseModal}
          />
        )}
      </Box>
    </Modal>
  );
});

PreviewPolicy.propTypes = {
  openModal: PropTypes.bool,
  onCloseModal: PropTypes.func,
  selectedPolicy: PropTypes.object,
};

PreviewPolicy.defaultProps = {
  openModal: false,
  onCloseModal: () => {},
  selectedPolicy: null,
};

export default PreviewPolicy;
